

// import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import AppModal from "../../../../../components/AppModal";
// import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable"; // Ensure you import the autoTable plugin
// import * as XLSX from "xlsx";
// import logo from '../../../../../assets/img/logos/logo 2.png';

// import RefreshIcon from '@mui/icons-material/Refresh';
// import { PrAnalysisTab3Api } from '../../../../../api/Api';

// // Function to get default dates
// const formatDateTime = (date) => {
//     const pad = (num) => String(num).padStart(2, "0");
//     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:00`;
// };

// function PrAnalysisTab4() {
//     const now = new Date();
//     const [startDate, setStartDate] = useState(formatDateTime(new Date(now.setHours(0, 0, 0))));
//     const [endDate, setEndDate] = useState(formatDateTime(new Date()));

//     const { palette, spacing, shape: { borderRadius } } = useTheme()
//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage] = useState(15);


//     const [OpenMix, setOpenMix] = useState(false);
//     const handleOpenMix = () => setOpenMix(true);
//     const handleCloseMix = () => setOpenMix(false);

//     // Fetch data dynamically based on updated StartDate, EndDate, and ID
//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);

//         const credentials = {
//             LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//             PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
//             LCODE: sessionStorage.getItem("LCODE"),
//             WEB_KEY: "xyz",
//             DT1: startDate,
//             DT2: endDate,
//             FID: ""

//         };

//         // console.log("data pram4 credentials:", logData);

//         try {
//             const res = await PrAnalysisTab3Api(credentials);
//             if (res?.KW && Array.isArray(res.KW)) {
//                 setLogData(res.KW);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(logData.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     // Get table headers from the first item in logData (dynamically)
//     const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

//     // Export to Excel
//     const exportToExcel = () => {
//         const ws = XLSX.utils.json_to_sheet(logData); // Directly use the full logData
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, `MIS_2`);
//         XLSX.writeFile(wb, `MIS_2 To ${endDate.replace(" ", "T")} MIS_2.xls`);
//     };

//     // Export to PDF
//     const exportToPDF = () => {
//         const doc = new jsPDF();

//         // Add Logo (x, y, width, height)
//         const imgWidth = 30;  // Adjust width
//         const imgHeight = 20; // Adjust height
//         const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
//         doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

//         // Add Title or Text Below the Logo
//         const title = `MIS_2 To ${endDate.replace(" ", "T")}`;
//         doc.setFontSize(12);  // Adjust font size
//         doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

//         // Adjust Y position for the table to start below the text
//         let startY = 50;  // Push table further down below text

//         doc.autoTable({
//             head: [tableHeaders],
//             body: logData.map((item) => tableHeaders.map((key) => item[key])),
//             startY: startY,  // Start table below the logo and text
//             theme: "grid",
//         });

//         doc.save(`MIS_2 To ${endDate.replace(" ", "T")} MIS_2`);
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [sessionStorage.getItem("LoginID")]);

//     // Refresh data only when clicking "Show"
//     function onRefreshData() {
//         if (startDate.length !== 0 && endDate.length !== 0) {
//             fetchLogData(); // Fetch data only after clicking the button
//         } else {
//             alert("Please provide valid dates");
//         }
//     }

//     const handleStartDateChange = (value) => {
//         const newDate = new Date(value);
//         const formattedDate = formatDateTime(newDate);
//         setStartDate(formattedDate);
//     };

//     const handleEndDateChange = (value) => {
//         const newDate = new Date(value);
//         const formattedDate = formatDateTime(newDate);
//         setEndDate(formattedDate);
//     };

//     return (
//         <>
//             <CssBaseline />
//             <Box bgcolor={'background.default'} py={spacing(1)}>

//                 <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: .4 }}>
//                     <Grid key="chart-grid" item xs={12}>
//                         <Card>
//                             <CardActions sx={{
//                                 display: "flex",
//                                 justifyContent: "flex-end",
//                                 alignItems: "center",
//                                 gap: "16px",
//                             }}>
//                                 <label>
//                                     <input
//                                         type="datetime-local"
//                                         value={startDate.replace(" ", "T")}
//                                         onChange={(e) => handleStartDateChange(e.target.value)}
//                                         style={{ padding: "2px 2px", borderRadius: "14px", border: "1px solid #ccc" }}
//                                     />
//                                 </label>
//                                 <label>
//                                     To
//                                     <input
//                                         type="datetime-local"
//                                         value={endDate.replace(" ", "T")}
//                                         onChange={(e) => handleEndDateChange(e.target.value)}
//                                         style={{ padding: "2px 2px", borderRadius: "14px", border: "1px solid #ccc" }}
//                                     />
//                                 </label>

//                                 <IconButton
//                                     onClick={onRefreshData}
//                                     sx={{
//                                         color: 'black',
//                                         // backgroundColor: palette.tintBlue,
//                                         borderRadius: borderRadius,
//                                         p: 1, // Adjust padding if needed
//                                     }}
//                                 >
//                                     <RefreshIcon sx={{ fontSize: '24px' }} />
//                                 </IconButton>

//                             </CardActions>
//                         </Card>
//                     </Grid>
//                 </Grid>

//                 <div style={{ padding: "4px", marginTop: ".4rem" }}>
//                     <div className="row">
//                         <div className="col-md-12">
//                             <div style={containerStyle} className="head">
//                                 <p style={responsiveHeaderStyle}></p>
//                                 <div style={responsiveControlsStyle}>
//                                     <button onClick={onRefreshData} style={buttonStyle}>Show</button>
//                                     <button onClick={exportToExcel} style={exportButtonStyle}>Excel</button>
//                                     <button onClick={exportToPDF} style={exportButtonStyle2}>PDF</button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="table-responsive">
//                         <table className="table table-hover table-bordered">
//                             <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//                                 <tr>
//                                     {tableHeaders.map((header, index) => (
//                                         <th key={index} style={tableHeading}>{header}</th>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {loading ? (
//                                     <tr>
//                                         <td colSpan={tableHeaders.length} className="text-center">Loading...</td>
//                                     </tr>
//                                 ) : currentData.length > 0 ? (
//                                     currentData.map((item, rowIndex) => (
//                                         <tr key={rowIndex}>
//                                             {tableHeaders.map((key, index) => (
//                                                 // <td key={index} className="text-center align-middle" style={tableBody}>
//                                                 //     {item[key] || ""}
//                                                 // </td>
//                                                 <td key={index} className="text-center align-middle" style={tableBody}>
//                                                     {item[key] ?? ""}
//                                                 </td>

//                                             ))}
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td colSpan={tableHeaders.length} className="text-center">No data available</td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>

//                     {/* Pagination */}
//                     <div style={{ textAlign: "right", marginTop: "10px" }}>
//                         <button
//                             onClick={() => handlePageChange(currentPage - 1)}
//                             disabled={currentPage === 1}
//                             style={paginationButtonStyle}
//                         >
//                             Previous
//                         </button>
//                         {[...Array(totalPages)].map((_, index) => (
//                             <button
//                                 key={index}
//                                 onClick={() => handlePageChange(index + 1)}
//                                 style={{
//                                     ...paginationButtonStyle,
//                                     backgroundColor: currentPage === index + 1 ? "#356E35" : "#356E35",
//                                     color: currentPage === index + 1 ? "#fff" : "#fff",
//                                 }}
//                             >
//                                 {index + 1}
//                             </button>
//                         ))}
//                         <button
//                             onClick={() => handlePageChange(currentPage + 1)}
//                             disabled={currentPage === totalPages}
//                             style={paginationButtonStyle}
//                         >
//                             Next
//                         </button>
//                     </div>
//                 </div>

//             </Box>
//         </>
//     );
// }

// export default PrAnalysisTab4;


// /* Styles */

// const containerStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     flexWrap: "wrap",
//     marginBottom: "7px",
//     border: "1px solid lightgray",
//     padding: "3px",
//     borderRadius: "7px"
// };

// const responsiveHeaderStyle = {
//     fontWeight: "bold",
//     margin: "0",
//     display: "flex",
//     flexWrap: "wrap"
// };

// const responsiveControlsStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "10px",
//     justifyContent: "center",
// };

// const inputStyle = {
//     padding: "2px 2px",
//     borderRadius: "14px",
//     border: "1px solid #ccc",
//     // marginLeft: "5px",
//     // fontSize: "10px",
// };

// const buttonStyle = {
//     backgroundColor: "#007BFF",
//     color: "#fff",
//     border: "none",
//     borderRadius: "14px",
//     padding: "2px 9px",
//     cursor: "pointer",
//     fontSize: "10px",
// };

// const exportButtonStyle = {
//     backgroundColor: "darkblue",
//     color: "#fff",
//     border: "none",
//     borderRadius: "14px",
//     padding: "3px 9px",
//     cursor: "pointer",
//     fontSize: "11px",
// };

// const exportButtonStyle2 = {
//     backgroundColor: "#f44336",
//     color: "#fff",
//     border: "none",
//     borderRadius: "14px",
//     padding: "3px 9px",
//     cursor: "pointer",
//     fontSize: "11px",
// };

// const paginationButtonStyle = {
//     backgroundColor: "white",
//     color: "#356E35",
//     border: "1px solid #ddd",
//     padding: "5px 10px",
//     borderRadius: "5px",
//     margin: "0 5px",
//     cursor: "pointer",
//     fontSize: "14px",
// };


// const tableHeading = {
//     color: "rgb(53, 110, 53)",
//     padding: "12px 10px",
//     fontSize: "14px",
//     whiteSpace: "nowrap",
// }

// const tableBody = {
//     padding: "5px",
//     whiteSpace: "nowrap",
// }





import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AppModal from "../../../../../components/AppModal";
import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../assets/img/logos/logo 2.png';

import RefreshIcon from '@mui/icons-material/Refresh';
import { PrAnalysisTab3Api } from '../../../../../api/Api';
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../api/AxiosApi'
import ExportExcel from '../../../../../components/exportExcel/ExportExcel1';
import { AuthenticationContext } from '../../../../../context/AuthenticationContext';
import ExportPdf from '../../../../../components/exportPdf/ExportPdf';

// Function to get default dates
const formatDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:00`;
};

function PrAnalysisTab4() {
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const now = new Date();
    const [startDate, setStartDate] = useState(formatDateTime(new Date(now.setHours(0, 0, 0))));
    const [endDate, setEndDate] = useState(formatDateTime(new Date()));

    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15);


    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const credentials = {
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
        LCODE: sessionStorage.getItem("LCODE"),
        WEB_KEY: "xyz",
        DT1: startDate,
        DT2: endDate,
        FID: ""

    };
    // Fetch data dynamically based on updated StartDate, EndDate, and ID
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

    

        // console.log("data pram4 credentials:", logData);

        try {
            const res = await PrAnalysisTab3Api(credentials);
            if (res?.KW && Array.isArray(res.KW)) {
                setLogData(res.KW);
            } else {
                setLogData([]);
            }
        } catch (err) {
            // console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(logData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Get table headers from the first item in logData (dynamically)
    const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

    // Export to Excel
    // const exportToExcel = () => {
    //     const ws = XLSX.utils.json_to_sheet(logData); // Directly use the full logData
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, `MIS_2`);
    //     XLSX.writeFile(wb, `MIS_2 To ${endDate.replace(" ", "T")} MIS_2.xls`);
    // };

    const exportToExcel = async () => {
        await ExportExcel(
            ImageUrl,
            logData,
            startDate,
            endDate,
            "MIS_2 Log",
            LoggedInUserInfo
        );
    };


    // Export to PDF
    // const exportToPDF = () => {
    //     const doc = new jsPDF();

    //     // Add Logo (x, y, width, height)
    //     const imgWidth = 30;  // Adjust width
    //     const imgHeight = 20; // Adjust height
    //     const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
    //     doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

    //     // Add Title or Text Below the Logo
    //     const title = `MIS_2 To ${endDate.replace(" ", "T")}`;
    //     doc.setFontSize(12);  // Adjust font size
    //     doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

    //     // Adjust Y position for the table to start below the text
    //     let startY = 50;  // Push table further down below text

    //     doc.autoTable({
    //         head: [tableHeaders],
    //         body: logData.map((item) => tableHeaders.map((key) => item[key])),
    //         startY: startY,  // Start table below the logo and text
    //         theme: "grid",
    //     });

    //     doc.save(`MIS_2 To ${endDate.replace(" ", "T")} MIS_2`);
    // };

    const exportToPDF = async () => {
        await ExportPdf(
            ImageUrl,
            currentData,
            startDate,
            endDate,
            `MIS_2 Log`,
            LoggedInUserInfo,
            logo,
            tableHeaders
    
        );
    };

    useEffect(() => {
        fetchLogData();
    }, [sessionStorage.getItem("LoginID")]);

    // Refresh data only when clicking "Show"
    function onRefreshData() {
        if (startDate.length !== 0 && endDate.length !== 0) {
            fetchLogData(); // Fetch data only after clicking the button
        } else {
            alert("Please provide valid dates");
        }
    }

    const handleStartDateChange = (value) => {
        const newDate = new Date(value);
        const formattedDate = formatDateTime(newDate);
        setStartDate(formattedDate);
    };

    const handleEndDateChange = (value) => {
        const newDate = new Date(value);
        const formattedDate = formatDateTime(newDate);
        setEndDate(formattedDate);
    };

    return (
        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} py={spacing(1)}>

                <Grid container style={{ padding: "0", margin: "0" }}>


                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

                        <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
                            {/* First Card */}
                            <Stack
                                component={Card}
                                p={spacing(1)}
                                sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                            >

                                <div>

                                    <div style={{
                                        marginBottom: "5px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: "16px",
                                    }}>
                                        {/* Left-side title */}
                                        <div style={{ marginLeft: "7px", fontSize: "14px"  }}>
                                          MIS_2
                                        </div>

                                        {/* Right-side date pickers */}
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px"
                                        }}>
                                            <label>
                                                From:&nbsp;
                                                <input
                                                    type="datetime-local"
                                                    value={startDate.replace(" ", "T")}
                                                    onChange={(e) => handleStartDateChange(e.target.value)}
                                                    style={{ padding: "2px 2px", borderRadius: "14px", border: "1px solid #ccc" }}
                                                />
                                            </label>
                                            <label>
                                                To:&nbsp;
                                                <input
                                                    type="datetime-local"
                                                    value={endDate.replace(" ", "T")}
                                                    onChange={(e) => handleEndDateChange(e.target.value)}
                                                    style={{ padding: "2px 2px", borderRadius: "14px", border: "1px solid #ccc" }}
                                                />
                                            </label>

                                            <button onClick={onRefreshData} style={buttonStyle}>Show</button>
                                            <button onClick={exportToExcel} style={exportButtonStyle}>Excel</button>
                                            <button onClick={exportToPDF} style={exportButtonStyle2}>PDF</button>



                                        </div>
                                    </div>


                                    <div style={{ padding: "4px", marginTop: ".4rem" }}>
                                        

                                        <div className="table-responsive">
                                            <table className="table table-hover table-bordered">
                                                <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                                                    <tr>
                                                        {tableHeaders.map((header, index) => (
                                                            <th key={index} style={tableHeading}>{header}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? (
                                                        <tr>
                                                            <td colSpan={tableHeaders.length} className="text-center">Loading...</td>
                                                        </tr>
                                                    ) : currentData.length > 0 ? (
                                                        currentData.map((item, rowIndex) => (
                                                            <tr key={rowIndex}>
                                                                {tableHeaders.map((key, index) => (
                                                                    // <td key={index} className="text-center align-middle" style={tableBody}>
                                                                    //     {item[key] || ""}
                                                                    // </td>
                                                                    <td key={index} className="text-center align-middle" style={tableBody}>
                                                                        {item[key] ?? ""}
                                                                    </td>

                                                                ))}
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={tableHeaders.length} className="text-center">No data available</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        <div style={{ textAlign: "right", marginTop: "10px" }}>
                                            <button
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                style={paginationButtonStyle}
                                            >
                                                Previous
                                            </button>

                                            {[...Array(totalPages)].map((_, index) => {
                                                const isActive = currentPage === index + 1;
                                                return (
                                                    <button
                                                        key={index}
                                                        onClick={() => handlePageChange(index + 1)}
                                                        style={{
                                                            ...paginationButtonStyle,
                                                            backgroundColor: isActive ? "#356E35" : "white",
                                                            color: isActive ? "#fff" : "#356E35",
                                                        }}
                                                    >
                                                        {index + 1}
                                                    </button>
                                                );
                                            })}

                                            <button
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                style={paginationButtonStyle}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </Stack>


                        </Stack>


                    </Grid>

                </Grid>

            </Box>
        </>
    );
}

export default PrAnalysisTab4;


/* Styles */

const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "7px",
    border: "1px solid lightgray",
    padding: "3px",
    borderRadius: "7px"
};

const responsiveHeaderStyle = {
    fontWeight: "bold",
    margin: "0",
    display: "flex",
    flexWrap: "wrap"
};

const responsiveControlsStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
};

const inputStyle = {
    padding: "2px 2px",
    borderRadius: "14px",
    border: "1px solid #ccc",
    // marginLeft: "5px",
    // fontSize: "10px",
};

const buttonStyle = {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "2px 9px",
    cursor: "pointer",
    fontSize: "10px",
};

const exportButtonStyle = {
    backgroundColor: "darkblue",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const exportButtonStyle2 = {
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const paginationButtonStyle = {
    backgroundColor: "white",
    color: "#356E35",
    border: "1px solid #ddd",
    padding: "5px 10px",
    borderRadius: "5px",
    margin: "0 5px",
    cursor: "pointer",
    fontSize: "14px",
};


const tableHeading = {
    color: "rgb(53, 110, 53)",
    padding: "12px 10px",
    fontSize: "14px",
    whiteSpace: "nowrap",
}

const tableBody = {
    padding: "5px",
    whiteSpace: "nowrap",
}






